import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Radio, RadioChangeEvent, Spin } from "antd";
import { ServiceLineType } from "../../../ducks/types";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element | null;
  btnText: string;
  btnApi: () => void;
  loading?: boolean;
  secondBtnText?: string;
  modalData: ServiceLineType[] | null;
  setServiceLineForLineItems?: React.Dispatch<
    React.SetStateAction<ServiceLineType | null>
  >;
  setServiceLineForMaterials?: React.Dispatch<
    React.SetStateAction<ServiceLineType | null>
  >;
}

const ChooseServiceLine = (props: PropsType) => {
  const {
    onClose,
    heading,
    paragraph,
    btnText,
    btnApi,
    loading,
    secondBtnText,
    modalData,
    setServiceLineForLineItems,
    setServiceLineForMaterials,
  } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const handleSelectedValue = (e: RadioChangeEvent) => {
    if (modalData) {
      const selectedServiceLine = modalData.find(
        (item) => item.id === e.target.value
      );
      if (selectedServiceLine && setServiceLineForLineItems) {
        setServiceLineForLineItems(selectedServiceLine);
      }
      if (selectedServiceLine && setServiceLineForMaterials) {
        setServiceLineForMaterials(selectedServiceLine);
      }
    }
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper ">
        <div className="modal_header">
          <div className="title">
            <h2 style={{ fontSize: "20px" }}> {heading} </h2>
          </div>
          {paragraph && <p style={{ marginTop: 12 }}>{paragraph} </p>}
        </div>

        <div className="modal_content">
          <Radio.Group
            className="serviceLineRadio"
            onChange={handleSelectedValue}
          >
            {modalData?.map((item) => (
              <Radio.Button key={item.id} value={item.id}>
                {item.name}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            {secondBtnText ? secondBtnText : "Cancel"}
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            {btnText}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default ChooseServiceLine;
